const getEnvValue = function (_env, _default) {
    // if _default param is a integer, parse the enviroment variable to int
    if (_env in process.env) {
        const _var = process.env[_env]
        if (typeof _default === 'number') {
            return parseInt(_var, 10)
        } else if (typeof _default === 'boolean') {
            if (_var.toLowerCase() == 'true') {
                return true
            } else {
                return false
            }
        } else {
            return _var
        }
    } else {
        return _default
    }
};

const publicUrl = getEnvValue('PUBLIC_URL', 'http://localhost:8080');
export const apiUrl = getEnvValue('REACT_APP_API_URL', 'http://localhost:8080/api');
export const dummyServer = getEnvValue('REACT_APP_DUMMY_SERVER', false);

export const intlLocale = getEnvValue('REACT_APP_INTL_LOCALE', 'en-US');

export const logoImage = `${publicUrl}/logo.png`;
export const logoTelmex = `${publicUrl}/telmex-logo-8.png`;
export const infoImage = `${publicUrl}/DSH.jpg`;

export const maxFileSize = getEnvValue('REACT_APP_MAX_FILE_SIZE_MB', 2) * 1024 * 1024;
export const showCustomerSuccess = getEnvValue('REACT_APP_SHOW_CUSTOMER_SUCCESS', true);
export const customerSuccessUrl = getEnvValue('REACT_APP_CUSTOMER_SUCCESS_REDIRECT_URL', 'https://www.arara.ai');
export const showNetworkTab = getEnvValue('REACT_APP_SHOW_NETWORK_TAB', true);
export const showLikesGraphOnAnalyticsTab = getEnvValue('REACT_APP_SHOW_LIKES_ON_ANALYTICS', true);

export const supportedImageFormats = [
    'image/jpg', 'image/jpeg', 'image/png', 'image/tif', 'image/gif',
    'image/bmp', 'image/dds', 'image/hdr', 'image/npbm', 'image/pgm',
    'image/ppm', 'image/pnm', 'image/psd', 'image/exr', 'image/gbr',
    'image/pdf', 'image/sgi', 'image/webp', 'image/xbm', 'image/xpm',
];

export const videoLocationUrl = getEnvValue('REACT_APP_VIDEO_LOCATION_URL', 'https://www.arara.ai/video/');
export const videoApiUrl = getEnvValue('REACT_APP_API_VIDEO_URL', 'http://service.api/video');
